import { Component } from '@angular/core';

@Component({
  selector: 'uni-filter-bar-content',
  templateUrl: './uni-filter-bar-content.component.html',
  styleUrls: ['./uni-filter-bar-content.component.scss'],
})
export class UniFilterBarContentComponent {}
